import React, { CSSProperties, SVGAttributes } from "react";
import styles from "./ColorCheckbox.module.scss";

const SIZE = 16;
const STROKE_WIDTH = 1;

type Props = {
  backgroundColor: CSSProperties["backgroundColor"];
  color: CSSProperties["color"];
  stroke: CSSProperties["stroke"];
} & SVGAttributes<SVGSVGElement>;
const ColorCheckbox = ({ color, backgroundColor, stroke, ...rest }: Props) => {
  return (
    <svg
      width={SIZE}
      height={SIZE}
      viewBox={`0 0 ${SIZE} ${SIZE}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles["color-checkbox"]}
      role={"checkbox"}
      {...rest}
    >
      <circle
        cx={SIZE / 2}
        cy={SIZE / 2}
        r={SIZE / 2 - STROKE_WIDTH}
        strokeWidth={STROKE_WIDTH}
        fill={backgroundColor}
        stroke={stroke}
      />
      <path
        d="M7 9L5.5 7.5C5.22386 7.22386 4.77614 7.22386 4.5 7.5C4.22386 7.77614 4.22386 8.22386 4.5 8.5L6.29289 10.2929C6.68342 10.6834 7.31658 10.6834 7.70711 10.2929L11.5 6.5C11.7761 6.22386 11.7761 5.77614 11.5 5.5C11.2239 5.22386 10.7761 5.22386 10.5 5.5L7 9Z"
        fill={color}
      />
    </svg>
  );
};

export default ColorCheckbox;
